export const companyInfo = {
  name: "3D's Card Data株式会社",
  nameEn: "3D's Card Data Inc.",
  founded: "2019年4月",
  capital: "4億8,000万円",
  representative: "佐藤 健一",
  representativeTitle: "代表取締役 CEO",
  employees: "86名（2025年4月現在）",
  address: "〒106-0032 東京都港区六本木6-10-1 六本木ヒルズ森タワー 22F",
  tel: "03-6441-3820",
  fax: "03-6441-3821",
  email: "admin@3dscarddata.jp",
  business: "3Dカードデータ解析、ビッグデータ分析、AI可視化ソリューションの開発・提供、データコンサルティング",
};

export const history = [
  { year: "2019年4月", event: "東京都港区六本木にて3D's Card Data株式会社を設立" },
  { year: "2019年10月", event: "3Dカードデータ解析エンジン「CardEngine V1」をリリース" },
  { year: "2020年6月", event: "大手カードゲーム企業3社とデータ解析パートナーシップを締結" },
  { year: "2021年3月", event: "シリーズAラウンドで12億円の資金調達を完了" },
  { year: "2022年1月", event: "AI可視化プラットフォーム「DataVision」提供開始" },
  { year: "2022年9月", event: "六本木ヒルズ森タワーへ本社を移転、従業員数50名突破" },
  { year: "2023年7月", event: "ビッグデータ分析ソリューション「BD Analyzer Pro」リリース" },
  { year: "2024年4月", event: "海外展開開始、シンガポールにアジア太平洋統括拠点を開設" },
  { year: "2025年1月", event: "特許取得（3Dカードパターン認識AI技術）、累計解析データ10億件突破" },
];

export const services = [
  {
    id: 'card-engine',
    title: '3Dカードデータ解析',
    titleEn: '3D Card Data Analytics',
    description: '独自開発のAIエンジンにより、3Dカードの微細なパターンや特徴を高精度で解析。真贋判定、グレーディング、市場価値予測まで一貫したデータ分析を提供します。',
    features: ['高精度AIパターン認識', 'リアルタイム真贋判定', '市場価値動向分析', 'グレーディング自動化'],
    imageSeq: 'service-card-engine',
  },
  {
    id: 'bigdata',
    title: 'ビッグデータ分析基盤',
    titleEn: 'Big Data Analytics Platform',
    description: '膨大なカードデータを統合管理し、統計分析から予測モデリングまでをシームレスに実行。データドリブンな意思決定を支援するエンタープライズ向け分析基盤です。',
    features: ['ペタバイト級データ処理', '予測分析モデリング', 'リアルタイムダッシュボード', 'カスタムレポート生成'],
    imageSeq: 'service-bigdata',
  },
  {
    id: 'datavision',
    title: 'AI可視化ソリューション',
    titleEn: 'AI Visualization Solution',
    description: '複雑なデータを直感的に理解できる3Dビジュアライゼーション。インタラクティブな操作でデータの深層に潜むインサイトを引き出し、プレゼンテーションやレポート作成を強力に支援します。',
    features: ['3Dインタラクティブ可視化', 'AR/VR表示対応', 'カスタムダッシュボード', 'API連携機能'],
    imageSeq: 'service-datavision',
  },
];

export const achievements = [
  { value: '10億+', label: '累計解析データ件数' },
  { value: '85+', label: '導入企業数' },
  { value: '99.7%', label: '解析精度' },
  { value: '12件', label: '取得特許数' },
];

export const partners = [
  '株式会社ブレインパッド',
  'ドットデータ株式会社',
  'データ・デザイン株式会社',
  '日本テラデータ株式会社',
  '株式会社FRONTEO',
  '株式会社コレクテスト',
];

export const testimonials = [
  {
    name: '山田 太郎',
    role: '株式会社TCGマーケット 代表取締役',
    quote: '3D\'s Card Dataの解析エンジンを導入してから、真贋判定の精度が飛躍的に向上しました。取引の信頼性が高まり、顧客満足度も大幅に改善しています。',
  },
  {
    name: '田中 美咲',
    role: 'グローバルカードオークション株式会社 データ戦略部長',
    quote: 'ビッグデータ分析基盤のおかげで、市場動向の予測精度が格段に上がりました。データドリブンな経営判断が可能になり、収益が前年比30%増加しました。',
  },
  {
    name: '鈴木 一郎',
    role: '株式会社データフォース CTO',
    quote: 'API連携の柔軟性が素晴らしく、自社システムとの統合もスムーズでした。技術サポートも迅速で、常に最新の解析技術を活用できています。',
  },
];